module.exports = __webpack_public_path__ + "img/email.4e42b208.svg";